import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  initAnalytics,
  registerPageViewTracking,
} from './analytics';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance
const router = createRouter({ routeTree });
const analyticsEnabled =
  import.meta.env.VITE_ENABLE_ANALYTICS == null
    ? true
    : ['1', 'true', 'yes', 'on'].includes(
        String(import.meta.env.VITE_ENABLE_ANALYTICS).trim().toLowerCase()
      );
if (
  initAnalytics({
    enabled: analyticsEnabled,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  })
) {
  registerPageViewTracking();
}

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
